import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './resources';
import {
  LANGUAGE_STORAGE_KEY,
  languageOptions,
  persistLanguage,
  readInitialLanguage,
  isAppLanguage,
  supportedLanguages,
  updateDocumentLanguage,
  type AppLanguage,
} from './language';

void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: readInitialLanguage(),
    fallbackLng: 'en',
    supportedLngs: [...supportedLanguages],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

i18n.on('languageChanged', (language) => {
  const nextLanguage: AppLanguage = isAppLanguage(language) ? language : 'en';
  updateDocumentLanguage(nextLanguage);
  persistLanguage(nextLanguage);
});

updateDocumentLanguage(readInitialLanguage());

export function changeAppLanguage(language: AppLanguage): void {
  if (!isAppLanguage(language)) return;
  void i18n.changeLanguage(language);
}

export function translate(key: string, options?: Record<string, unknown>): string {
  return i18n.t(key, options);
}

export { LANGUAGE_STORAGE_KEY, languageOptions, supportedLanguages };
export type { AppLanguage };
export {
  formatErrorWithCode,
  formatMessageWithCode,
  getErrorCode,
  localizeError,
} from './error-localizer';

export default i18n;
